import $i from "~/i18n";
export const addNewCat = async (context, payload) => {
  try {
    let { data } = await axios.post("/category/new", payload);
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );

    context.commit("setNewCat", { id: data.category_id, ...payload });
    // console.log(data);
  } catch (error) {
    console.log(error);
  }
};
export const getAllCategory = async (context, payload) => {
  try {
    let { data } = await axios.post("/category/get-all");
    if (data.state != 200) return;
    context.commit("setList", data["category-list"]);
  } catch (error) {
    console.log(error);
  }
};
export const updateCat = async (context, payload) => {
  try {
    let { data } = await axios.post("/category/update", payload);
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const deleteCat = async (context, payload) => {
  try {
    let { data } = await axios.post("/category/delete", { id: payload.id });
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    context.commit("removeByIndex", payload.index);
  } catch (error) {
    console.log(error);
  }
};
export const getAllSubCategories = async ({ commit }) => {
  try {
    let { data } = await axios.post(`/subcategory/get-all`);
    commit("setAllsubCategories", data.subcategories);
  } catch (e) {
    console.log(e);
    return e;
  }
};
export const addSubCat = async ({ commit }, payload) => {
  try {
    let { data } = await axios.post(`/subcategory/new`, payload);
    if (data.state != 200) return;
    // TODO push in subcatList
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (e) {
    console.log(e);
    return e;
  }
};
export const updateSubCat = async (context, payload) => {
  try {
    let { data } = await axios.post("/subcategory/update", payload);
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const deleteSubCat = async (context, payload) => {
  try {
    let { data } = await axios.post("/subcategory/delete", { id: payload.id });
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    context.commit("removeByIndexSubCat", payload.index);
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/category/actions.js